import React from "react";
import { Link } from "react-router-dom";
import image1 from "../assets/home-images/Frame-1.png";
import image2 from "../assets/home-images/Frame-line.svg";
import image3 from "../assets/home-images/Frame5913.svg";
import image4 from "../assets/home-images/Frame5914.svg";
import image5 from "../assets/home-images/Frame5915.svg";
import image6 from "../assets/home-images/Frame5916.svg";
import image7 from "../assets/home-images/Frame5917.svg";
import image8 from "../assets/home-images/Frame5918.svg";
import image9 from "../assets/home-images/Group29.svg";
import image10 from "../assets/home-images/Group3.svg";
import image11 from "../assets/home-images/tech-own.jpg";
import image12 from "../assets/home-images/double.svg";
import image13 from "../assets/home-images/admin.svg";
import image14 from "../assets/home-images/developer.svg";
import image16 from "../assets/home-images/implementer.svg";
import image15 from "../assets/home-images/Frame-3.png";
import "../pages/Global.css";
import AOS from "aos";
import "aos/dist/aos.css";


const Home = () => {

  AOS.init({
    disable: function () {
      return window.innerWidth < 768;
    },

    
    startEvent: "DOMContentLoaded",
    initClassName: "aos-init",
    animatedClassName: "aos-animate",
    useClassNames: false,
    disableMutationObserver: false,
    debounceDelay: 50,
    throttleDelay: 99,

  
    offset: 80,
    delay: 50,
    duration: 600, 
    easing: "ease-out", 
    once: false, 
    mirror: false, 
    anchorPlacement: "top-bottom",
  });







  return (
    <>
      {/* Section 1 */}
      <div
        className="home_herosection min-h-[500px] px-6 py-16 md:px-12 lg:px-20"
      >
        <div className="flex flex-col gap-6 max-w-2xl" data-aos="fade-down">
          <h1
            className="text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-snug"
            style={{ wordSpacing: "5px" }}
            data-aos="fade-in"
          >
            Explore the Full Potential of ServiceNow.
          </h1>

          <p
            className="text-white text-base md:text-lg leading-relaxed"
            data-aos="fade-in"
          >
            Transform your business with ServiceNow. We'll help you improve
            efficiency, enhance customer and employee experiences, and drive
            sustainable growth.
          </p>

          <Link
            to="/contact-us"
            className="w-fit px-6 py-3 text-white font-medium text-sm md:text-base rounded-lg bg-[#C32A7C] hover:bg-white hover:text-[#C32A7C] transition-all duration-300 ease-in-out shadow-md"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            Contact Us
          </Link>
        </div>
      </div>

      {/* Section 2 */}
      <div className="sec2 flex flex-col md:flex-row justify-center px-4 py-12 md:px-6 md:py-16 lg:px-10 w-full gap-8 md:gap-5">
        <div className="mb-8 md:mb-0 flex secchild1" data-aos="fade-up">
          <img
            className="w-[90%] max-w-[417px] h-auto md:max-h-[390px] object-cover rounded-lg transition-shadow duration-300"
            src={image1}
            alt=""
          />
        </div>
        <div className="w-full md:w-1/2 md:mt-14" data-aos="fade-up">
          <img className="mb-2 w-20 max-h-10" src={image2} alt="" />
          <h2 className="text-black font-semibold text-xl md:text-3xl mt-2 md:mt-5">
            Our Service Approach
          </h2>
          <p className="text-black mt-2 md:mt-5 w-full md:w-2/3 lg:w-3/4 text-sm md:text-base">
            Whether you're a seasoned ServiceNow user or just beginning, we
            offer tailored services to support your journey.
          </p>
        </div>
      </div>


      {/* Section 3 */}
      <div className="flex flex-col justify-start px-4 py-8 md:py-12 lg:py-16 bg-[#F0FAFF]">
        <div className="relative">
          <div
            className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 px-6 gap-3 py-5"
            data-aos="zoom-in-down"
          >
            {[
              {
                img: image3,
                title: "Business Strategy",
                desc: "Get the most out of your ServiceNow investment and reach your targets with our tailored approach and KPI monitoring.",
                link: "/services/managed-service",
              },
              {
                img: image4,
                title: "Service Management",
                desc: "We're with you every step of the way on your ServiceNow journey, providing comprehensive assistance.",
                link: "/services/strategic-planning",
              },
              {
                img: image5,
                title: "Software Implementation",
                desc: "Experience a smooth and successful ServiceNow implementation with our customized approach.",
                link: "/services/platform-implementation",
              },
              {
                img: image8,
                title: "IT Consulting",
                desc: "Collaborate with our expert ServiceNow team for a smooth and effective co-delivery experience.",
                link: "/services/technical-consultation",
              },
              {
                img: image6,
                title: "ServiceNow Enhancement",
                desc: "Clear technical debt, refine customization, and seize new opportunities with our expert optimization services.",
                link: "/services/servicenow-optimization",
              },
              {
                img: image7,
                title: "System Automation",
                desc: "Automate workflows with precision, tailored for increased productivity and streamlined operations.",
                link: "/services/platform-automation",
              },
            ].map((service, index) => (
              <div
                key={index}
                className="sec3 flex flex-col items-center text-center mt-20 transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
              >
                <div className="w-full bg-gradient-to-r from-[#981A59] to-[#124B6A] h-[10px]"></div>
                <div className="flex flex-col items-center rounded border bg-[#FFFFFF] flex-1 w-full p- hover: transition-all duration-300">
                  <img
                    className="-mt-10 transform transition-transform duration-300"
                    src={service.img}
                    alt={service.title}
                  />
                  <h3 className="sec3title text-lg font-semibold mt-4 text-[#000]">
                    {service.title}
                  </h3>
                  <p className="text-sm text-black mt-2 flex-grow lg:w-[300px]">
                    {service.desc}
                  </p>
                  <div className="mt-6 flex flex-col items-center">
                    <a
                      rel="noopener noreferrer"
                      href={service.link}
                      className="text-[#C32A7C] text-sm hover:underline hover:text-[#981A59] transition-colors duration-300"
                    >
                      Learn More
                    </a>
                    <img
                      className="w-12 h-5 object-contain mb-5 transform transition-transform duration-300 hover:translate-y-1"
                      src={image9}
                      alt="Icon"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section 4 */}
      <div className="bg-white">
        <div className="flex justify-start px-4 md:px-10 lg:px-10 py-8 mt-8">
          <h1 className="text-lg md:text-3xl font-bold text-[#1A5298] w-3/2 md:max-w-[650px]">
            Elevate Your Business Performance with Our ServiceNow Expertise
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-4 md:px-10 py-10">
          {/* Box 1 */}
          <div
            className="bg-[#F6F6F6] rounded-lg p-10 flex flex-col items-center w-full text-center justify-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#F6F6F6] group"
            data-aos="flip-up"
          >
            <h2 className="text-[#1A5298] text-lg font-semibold mb-4 group-hover:tracking-wider transition-all duration-300">
              Enhance IT
              <br />
              Workflows
            </h2>
            <div className="mt-2 flex flex-col items-center md:w-40">
              <img
                className="object-contain group-hover:scale-110 transition-transform duration-300"
                src={image10}
                alt="Enhance IT Workflows"
              />
            </div>
          </div>

          {/* Box 2 */}
          <div
            className="bg-[#F6F6F6] rounded-lg p-10 flex flex-col items-center w-full text-center justify-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#F6F6F6] group"
            data-aos="flip-up"
          >
            <h2 className="text-[#1A5298] text-lg font-semibold mb-4 group-hover:tracking-wider transition-all duration-300">
              Optimize Employee
              <br />
              Workflows
            </h2>
            <div className="mt-2 flex flex-col items-center md:w-40">
              <img
                className="object-contain group-hover:scale-110 transition-transform duration-300"
                src={image10}
                alt="Optimize Employee Workflows"
              />
            </div>
          </div>

          {/* Box 3 */}
          <div
            className="bg-[#F6F6F6] rounded-lg p-10 flex flex-col items-center w-full text-center justify-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#F6F6F6] group"
            data-aos="flip-up"
          >
            <h2 className="text-[#1A5298] text-lg font-semibold mb-4 group-hover:tracking-wider transition-all duration-300">
              Improve Customer
              <br />
              Workflows
            </h2>
            <div className="mt-2 flex flex-col items-center md:w-40">
              <img
                className="object-contain group-hover:scale-110 transition-transform duration-300"
                src={image10}
                alt="Improve Customer Workflows"
              />
            </div>
          </div>

          {/* Box 4 */}
          <div
            className="bg-[#F6F6F6] rounded-lg p-10 flex flex-col items-center w-full text-center justify-center transform transition-all duration-300 hover:scale-105 hover:shadow-lg hover:bg-[#F6F6F6] group"
            data-aos="flip-up"
          >
            <h2 className="text-[#1A5298] text-lg font-semibold mb-4 group-hover:tracking-wider transition-all duration-300">
              Refine Creator
              <br />
              Workflows
            </h2>
            <div className="mt-2 flex flex-col items-center md:w-40">
              <img
                className="object-contain group-hover:scale-110 transition-transform duration-300"
                src={image10}
                alt="Refine Creator Workflows"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Section 5 */}
      <div className="bg-[#F6F6F6] w-full py-10 md:py-15 mt-6">
        <div className="flex flex-col md:flex-row px-4 md:px-10 lg:px-20 gap-8 md:gap-16">
          <div
            className="flex justify-center md:justify-start"
            data-aos="zoom-in-down"
          >
            <img
              src={image11}
              alt="Client Logo"
              className="max-w-[150px] md:max-w-[250px] md:max-h-[200px] lg:max-w-[330px] lg:max-h-[330px]"
            />
          </div>
          <div className="md:w-2/3 flex gap-2">
            <div className="mb-4">
              <img
                src={image12}
                alt="Quote Icon"
                className="max-w-[30px] md:max-w-[30px]"
              />
            </div>
            <div>
              <p className="text-black text-sm md:text-base mb-4 max-w-full md:max-w-2/3 lg:max-w-[700px]">
                Tekpossible has been a true partner in helping us optimize our
                processes. We appreciate your team's commitment to continuous
                improvement, consistently suggesting better ways of doing things
                and facilitating discussions that challenge our assumptions.
                Your willingness to push us to rethink our approach, especially
                when you see opportunities for improvement based on your
                experience elsewhere, is invaluable.
              </p>
              <div>
                <h1 className="text-black font-bold mb-1 text-sm md:text-lg">
                  Adithya Masetti – Sr. Software
                  <br /> Developer
                </h1>
                <a
                  href="/"
                  rel="noopener noreferrer"
                  className="text-[#1A5298] font-bold text-xs md:text-sm"
                >
                  benchtrack.ai
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 6 */}
      <div className="bg-white flex flex-col sm:flex-row justify-between items-center py-10 md:py-16 px-4 md:px-10 lg:px-20">
        {/* Text Content */}
        <div className="mb-8 sm:mb-0 flex-1" data-aos="zoom-in-down">
          <img className="w-20 h-5 mb-3" src={image2} alt="Logo" />
          <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-2 text-[#1A5298] max-w-[382px]">
            Expert Members of the ServiceNow Community
          </h1>
          <p className="text-sm sm:text-base mt-6 max-w-[700px]">
            Our ServiceNow Community at Tekpossible consists of hundreds of certified developers, implementation specialists, and administrators. Whether it's staff augmentation, production support, or end-to-end ServiceNow solution development, we have you covered.
          </p>
        </div>

        {/* Image Container */}
        <div className="flex flex-row flex-wrap justify-center items-center gap-5 mt-8 sm:mt-0 overflow-hidden">
          <div className="flex justify-center transform transition-transform duration-300 hover:scale-105 group">
            <img
              src={image13}
              alt=""
              className="max-w-[127px] max-h-[127px] transition-opacity duration-300 group-hover:opacity-80 animate-slow-shake"
            />
          </div>
          <div className="flex justify-center transform transition-transform duration-300 hover:scale-105 group">
            <img
              src={image14}
              alt=""
              className="max-w-[127px] max-h-[127px] transition-opacity duration-300 group-hover:opacity-80 animate-slow-shake"
            />
          </div>
          <div className="flex justify-center transform transition-transform duration-300 hover:scale-105 group">
            <img
              src={image16}
              alt=""
              className="max-w-[127px] max-h-[127px] transition-opacity duration-300 group-hover:opacity-80 animate-slow-shake"
            />
          </div>
        </div>
      </div>

      {/* Section 7 */}
      <div className="bg-white py-10 md:py-16 mt-6">
        <div data-aos="zoom-in-down" className="flex flex-col sm:items-center items-center md:items-start lg:items-start xl:items-start md:flex-row px-4 md:px-10 lg:px-20 gap-8 md:gap-16">
          <img
            src={image15}
            alt="Client Logo"
            className="w-[150px] md:w-[200px] lg:w-[350px] transform transition-transform duration-300 hover:scale-105"

          />
          <div
            className="md:w-2/3 text-center md:text-left"

          >
            <div className="flex justify-center md:justify-start">
              <img src={image2} alt="Line" className="w-20 h-5 mb-4" />
            </div>

            <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-2xl xl:text-3xl mb-4 lg:w-2/2 xl:w-3/5">
              Results that can be measured are what truly matter
            </h1>

            <p className="text-sm md:text-base lg:w-4/3 xl:w-3/4">
              Explore the real-world outcomes of our consulting expertise and
              domain knowledge.
            </p>
          </div>
        </div>
      </div>

      {/* Section 8 */}
      <div
        className="bg-[#FFFFFF] w-full py-10 md:py-16 mt-6"

      >
        <div className="flex flex-col items-center text-center px-4 md:px-6">
          <h1 data-aos="zoom-in-down" className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-2/4">
            What can we help your business achieve with ServiceNow?
          </h1>

          <Link
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold
                 hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base
                 text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
            data-aos="zoom-in"
            data-aos-delay="300"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </>
  );
};

export default Home;
